import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=5e74d5b6"
import script from "./SettingsHeader.vue?vue&type=script&lang=ts"
export * from "./SettingsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports